// =============================================================================
// Class strings shared by the views (static literals, so Tailwind sees them)
// =============================================================================

/** Hatching of the disabled spans and days, tinted from the foreground */
export const DISABLED_HATCH =
  "bg-[repeating-linear-gradient(-45deg,transparent,transparent_6px,color-mix(in_oklab,var(--foreground)_6%,transparent)_6px,color-mix(in_oklab,var(--foreground)_6%,transparent)_12px)]";

/** Popovers skip their zoom / slide entrance when motion is reduced */
export const POPOVER_CLASSES = "w-72 border-line motion-reduce:animate-none!";
